<template>
  <div class="product-accordion m-0 p-0 list-none max-w-full">
    <button
      class="ota-p18 w-full text-left items-center flex pb-4 focus:outline-none"
      @click="onClick"
    >
      <div class="flex-1 cursor-pointer">
        <slot name="trigger" />
      </div>
      <div v-if="hasContentSlot">
        <OSvg
          class="text-gray-500 fill-current w-4"
          svg="arrow-down"
        />
      </div>
    </button>

    <div
      v-if="hasContentSlot"
      v-show="active"
      class="pt-5 ota-p16 font-light"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'ProductAccordion',
  components: {
    OSvg
  },
  data () {
    return {
      active: false
    }
  },
  computed: {
    hasContentSlot () {
      return !!this.$slots.content
    }
  },
  methods: {
    onClick () {
      this.active = !this.active

      this.$emit('click', this.active)
    }
  }
}
</script>
